import { CustomMarker } from './custom-marker.model';
import { GmapsTravelMode } from './../gmaps-interface/gmaps-travel-mode.model';
import { Component, Input, Injector, Inject, ViewChild, PLATFORM_ID } from '@angular/core';
import { GmapsHelpers } from '../gmaps-helpers.model';
import { AgencyService } from '../../api/agency.service';
import { GtagService } from './../../analytics/gtag.service';
import { FbqService } from './../../analytics/fbq.service';
import { GmapsInterfaceComponent } from '../gmaps-interface/gmaps-interface.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss']
})

export class GoogleMapComponent extends GmapsHelpers {
  @ViewChild(GmapsInterfaceComponent) gmapsInterface: GmapsInterfaceComponent;
  @Input() pathColor: string;
  @Input() customStyle: any;
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() zoom: number = 16;
  @Input() travelModes: GmapsTravelMode[] = [];
  @Input() customMarkers: CustomMarker[] = [];
  public isHidden: boolean = false;

  constructor(
    injector: Injector,
    public gtagService: GtagService,
    public fbqService: FbqService,
    public agencyService: AgencyService,
    @Inject(PLATFORM_ID) public platformId: object,
    @Inject('WINDOW') public window: any
  ) {
    super(injector);
  }

  public clickedMarker(latitude: number, longitude: number): void {
    if (isPlatformBrowser(this.platformId) && this.window) {
      this.window.open('https://maps.google.com?daddr='
        + latitude + ','
        + longitude + '&amp;ll=');

      this.gtagService.sendEvent('contact', 'click', 'maps_click');
      this.fbqService.sendEvent('Lead', { content_name: 'maps_click', content_category: 'click' });
    }
  }

  public updateDirectionsPath($event: any): void {
    if (this.travelModes && this.travelModes.length)
      this.updatePath($event.coords.lat, $event.coords.lng);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/google-map/google-map.component.ts